import { Action } from '@interstate/components/Action';
import { Alert } from '@interstate/components/Alert';
import type { AlertSeverity } from '@interstate/components/Alert/Types/alertTypes';
import { Typography } from '@interstate/components/Typography';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as customerRiskAndCoverageActionCreators from '@makemydeal/dr-dash-store/actions/customerRiskAndCoverageActionCreators';

import { useDispatch } from 'react-redux';

export type ComplianceAlertProps = {
    type: AlertSeverity;
    message: {
        title: string;
        description?: string;
    };
};
export const ComplianceAlert = ({ type, message }: ComplianceAlertProps) => {
    const dispatch = useDispatch();
    return (
        <Alert
            disableSuccessFade={true}
            type={type}
            sx={{ marginBottom: '0.7rem' }}
            data-testid={type === 'success' ? 'complaince-alert-success' : 'complaince-alert-error'}
        >
            <Typography tag="div" variant="body-sm" data-testid="compliance-alert-title">
                <b>{message.title}</b>
                <br />
            </Typography>

            {message.description && (
                <Typography tag="div" variant="body-sm" data-testid="compliance-alert-description">
                    {message.description}
                </Typography>
            )}

            {type === 'error' && (
                <Typography tag="div" variant="body-sm" data-testid="compliance-alert-error-link">
                    Please view the{' '}
                    <Action
                        data-testid="programs-link"
                        sx={{ padding: '0 0 0 4px', border: '0', display: 'inline' }}
                        onClick={() => {
                            dispatch(baseDealActionCreators.setCustomerRiskAndCoverageTab('compliance'));
                            dispatch(baseDealActionCreators.setCustomerRiskAndCoverageSlideOutStatus(true));
                            dispatch(customerRiskAndCoverageActionCreators.customerRiskAndCoverageSlideOutButton());
                        }}
                    >
                        <h6
                            style={{
                                color: '#007bff',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                fontSize: '1rem'
                            }}
                        >
                            OFAC/Red Flag Report
                        </h6>
                    </Action>
                </Typography>
            )}
        </Alert>
    );
};
